import Vue from "vue";
import Router from "vue-router";
import firebase from "firebase";
import appHome from "./components/Home";
import appForm from "./components/form/Form";
import appDiets from "./components/diets/Diets";
import appHistory from "./components/history/History";

Vue.use(Router);
const router = new Router({
  mode: "history",
  routes: [
    {
      path: "*",
      redirect: "/"
    },
    {
      path: "/",
      name: "Home",
      component: appHome
    },
    {
      path: "/calcular-dieta",
      name: "calcular-dieta",
      component: appForm,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/gerenciar-dietas",
      name: "gerenciar-dietas",
      component: appDiets,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/historico",
      name: "historico",
      component: appHistory,
      meta: {
        requiresAuth: true
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  if (requiresAuth && !currentUser) next("home");
  // else if (!requiresAuth && currentUser) next("calcular-dieta");
  else next();
});

export default router;
